<pds-module-header title="Otimizador">
  <pds-new-breadcrumb [items]="breadcrumb" />

  <pds-tabs [tabs]="tabs" (selected)="onTabSelected($event)">
    <router-outlet></router-outlet>
  </pds-tabs>
</pds-module-header>
